import { Segmented } from 'antd'
import { SegmentedValue } from 'antd/lib/segmented'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { BitazzaText } from '../../../../../components'
import Styles from './Chart.module.scss'

interface Props {
    onTableSegment: (value: string) => void
    segmentValue: string
}

export const ChartSegment: FC<Props> = ({ onTableSegment, segmentValue }) => {
    const { t } = useTranslation()
    return (
        <>
            <Segmented
                className={Styles.segment}
                defaultValue={segmentValue}
                onChange={(value: SegmentedValue) =>
                    onTableSegment(value as string)
                }
                options={[
                    {
                        label: (
                            <div className={Styles.segmentWrapper}>
                                <BitazzaText
                                    content="PNL"
                                    format="t14"
                                    color="#fff"
                                    display="block"
                                    lineHeight={14}
                                />
                            </div>
                        ),
                        value: 'ps',
                    },
                    {
                        label: (
                            <div className={Styles.segmentWrapper}>
                                <BitazzaText
                                    content={t('txt_performance')}
                                    format="t14"
                                    color="#fff"
                                    display="block"
                                    lineHeight={14}
                                />

                                <BitazzaText
                                    content={t('text_index')}
                                    format="t14"
                                    color="#fff"
                                    lineHeight={14}
                                />
                            </div>
                        ),
                        value: 'nav',
                    },
                ]}
            />
        </>
    )
}
